module.exports = new __parcel__URL__("trophy.634e454a.svg").toString();